import {
    DefaultTransportVehicleShiftEnd,
    DefaultTransportVehicleShiftStart
} from '@/constants/transport-vehicle-shift';
import type {Transport} from "@/models/transport/transport";
import type {PaginatedRequest} from "@/models/pagination";
import type {Chauffeur} from "@/models/chauffeur/chauffeur";
import { Country } from '@/constants/country';
import type {FilterOptions} from '@/models/filter';

export interface TransportVehicle {
    id: number,
    name: string,
    country: Country,
    licensePlate: string,
    chassisNumber: string,
    brand: string,
    remark?: string,
    showInApp: boolean,
    maxMass?: number,
    maxPayloadMass?: number,
    isActive: boolean,
    capacity: number,
    /** Begin van de dienst (HH:mm:ss). Gaat als shift_start naar de planning. */
    shiftStart: string,
    /** Einde van de dienst (HH:mm:ss), altijd na shiftStart. */
    shiftEnd: string,
    /** Of het voertuig een lier heeft; alleen dan kan het een niet-rijdbare auto vervoeren. */
    hasWinch: boolean,
    baseFarePrice: number,
    farePricePerKm: number,
    organizationId: number,
    stationedAtId?: number | null,
    defaultChauffeurId?: string,
    defaultChauffeur?: Chauffeur,
    transports: Transport[],
    canBeDeleted: boolean,
    isPlanned: boolean,
}

export interface TransportVehicleListModel {
    id: number,
    name: string,
    licensePlate: string,
    chassisNumber: string,
    country: Country,
    brand: string,
    isActive: boolean,
    capacity: number,
    baseFarePrice: number,
    farePricePerKm: number,
    remark?: string
    /** Draagvermogen in kilogrammen. */
    maxPayloadMass?: number | null,
    /** Standplaats: naam + plaats van de relatie waar het voertuig gestationeerd is. */
    stationedAtName?: string | null,
    stationedAtCity?: string | null,
    defaultChauffeur?: Chauffeur,
    isPlanned?: boolean
}

export interface TransportVehicleListRequest extends PaginatedRequest {
    name?: string | null,
    licensePlate?: string | null,
    brand?: string | null,
    isActive?: boolean | null,
    capacity?: number | null,
    baseFarePrice?: number | null,
    farePricePerKm?: number | null,
    remark?: string | null,
    defaultChauffeur?: string | null,
    plannedOn?: number | null,
    currentTransportId?: number | null,
    filterOptions: FilterOptions;
}

export const DefaultTransportVehicle = () => {
    return {
        id: 0,
        name: "",
        country: Country.NL,
        licensePlate: "",
        chassisNumber: "",
        brand: "",
        remark: undefined,
        showInApp: true,
        maxMass: undefined,
        maxPayloadMass: undefined,
        isActive: true,
        capacity: 1,
        shiftStart: DefaultTransportVehicleShiftStart,
        shiftEnd: DefaultTransportVehicleShiftEnd,
        hasWinch: false,
        baseFarePrice: 0,
        farePricePerKm: 0,
        organizationId: 0,
        stationedAtId: null,
        defaultChauffeurId: undefined,
        transports: [],
        defaultChauffeur: undefined,
        canBeDeleted: false,
        isPlanned: false
    } as TransportVehicle
}
